import React from 'react'
import {Link} from 'react-router-dom'
import '../styles/sideBtn.css'
import { useLocation } from "react-router-dom";
import { useState } from 'react';


import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import VideoCallOutlinedIcon from '@material-ui/icons/VideoCallOutlined';
import DialogBox from './DialogBox';
import Profile from '../pages/Profile/Profile';
import Zoom from '@material-ui/core/Zoom';
import Tooltip from '@material-ui/core/Tooltip';
import NEUniteLogo from '../assets/svg/Logo.svg';

const SideNavButtons = () => {
    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");
    const [profileModal, setProfileModal] = useState(false); 
    const [show, setShow] = React.useState(false);
    return (
    <div className='sideBar'>
            <img
                src={NEUniteLogo}
                alt="logo"
                className='logo'
                />
            <ul className = 'sideBar-btn'>
                
                <Tooltip TransitionComponent={Zoom} disableFocusListener title="Messages" placement="right"  >
                    <li className={`btn ${splitLocation[1] === "messages" ? "active" : ""}`} >
                        <Link to='/messages' >
                            <ChatOutlinedIcon />
                        </Link>
                    </li>
                </Tooltip>
                <Tooltip TransitionComponent={Zoom} disableFocusListener title="Virtual Room" placement="right" arrow>
                    <li className={`btn ${splitLocation[1] === "virtualroom" ? "active" : ""}`}>
                        <Link to="/virtualroom">
                            <VideoCallOutlinedIcon />
                        </Link>
                    </li>
                </Tooltip>
                <Tooltip  
                    TransitionComponent={Zoom} 
                    disableHoverListener 
                    title="Profile" 
                    placement="right" 
                    arrow
                    open={show}
                    onMouseEnter={() => setShow(true)} 
                    onMouseLeave={() => setShow(false)} 
                    >
                    <li className = {`btn ${profileModal === true ? "active" : ""}`}>
                    <DialogBox
                            title="Profile"
                            modalOpen={profileModal}
                            setModalOpen={setProfileModal}
                            triggerButton={
                                <button 
                                onClick={() => {setProfileModal(true); setShow(false);}}>
                                    <PersonOutlineOutlinedIcon/>
                                </button>
                                }
                                children={
                                <Profile closeModal={() => setProfileModal(false)} />
                                }
                        />
                    </li>
                </Tooltip>
            </ul>
       
    </div>
    );
};

export default SideNavButtons;
